import { render, staticRenderFns } from "./CustomFolderViewConfig.vue?vue&type=template&id=7299635c&scoped=true&"
import script from "./CustomFolderViewConfig.vue?vue&type=script&lang=js&"
export * from "./CustomFolderViewConfig.vue?vue&type=script&lang=js&"
import style0 from "./CustomFolderViewConfig.vue?vue&type=style&index=0&id=7299635c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7299635c",
  null
  
)

export default component.exports